var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('span',{staticClass:"text-uppercase"},[_vm._v("SQL Statement")]),_c('div',{staticClass:"query-wrapper mt-4"},[_c('pre',{staticClass:"pa-4",domProps:{"textContent":_vm._s(_vm.query)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }